import { ExternalLink } from "lucide-react";

/**
 * MadeByWebsiteTech — soft attribution footer.
 * Renders unconditionally as a slim horizontal band at the bottom of a client
 * brand page (QST, LitLab, and future clients). Kept intentionally quiet so
 * it doesn't compete with the brand's own footer.
 */
export default function MadeByWebsiteTech({ variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <div
      className={`border-t ${isDark ? "border-white/10 bg-slate-950 text-slate-400" : "border-slate-200 bg-slate-50 text-slate-500"}`}
      data-testid="made-by-websitetech"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs sm:flex-row">
        <span>Site built and operated on the WebsiteTech.pro platform.</span>
        <a
          href="https://websitetech.pro"
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center gap-1 font-semibold transition ${isDark ? "text-slate-200 hover:text-orange-400" : "text-slate-700 hover:text-orange-600"}`}
        >
          Made by <span className="text-orange-600">WebsiteTech.pro</span>
          <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </div>
  );
}
